import React from "react";
import { useTheme } from "styled-components";

const RewardTierIcon = ({ size, tier }) => {
  const {
    colors: { ribbonColors },
  } = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 37 37"
      fill="none"
    >
      <path
        d="M10.6616 21.0029L18.247 16.3893V30.4863L10.6616 35.0999V21.0029Z"
        fill={ribbonColors[tier].left}
      />
      <path
        d="M26.3379 21.0029L18.7525 16.3893V30.4863L26.3379 35.0999V21.0029Z"
        fill={ribbonColors[tier].right}
      />
      <circle
        cx="18.4998"
        cy="13.0223"
        r="11.1252"
        fill={ribbonColors[tier].top}
      />
    </svg>
  );
};

export default RewardTierIcon;
